import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const autoscroll_item = document.querySelector(".policy-autoscroll");

// Function to create the scroll animation
function createScrollAnimation() {
    if(!autoscroll_item) {
        return;
    }

    const wrapHeight = document.querySelector('.policy-autoscroll__right').clientHeight;
    const rightHeight = document.querySelector('.policy-autoscroll__right .inner').offsetHeight;
    const scrollDistance = rightHeight - wrapHeight;
    const containerHeight = document.querySelector('.policy-autoscroll').offsetHeight;

    // console.log('Scroll Distance:', scrollDistance);
    
    // Only create scroll animation if there's enough content to scroll
    if (scrollDistance <= 0) {
        return null;
    }

    const tl = gsap.timeline();

    tl.to('.policy-autoscroll__right .inner', {
        y: () => {
            return -(scrollDistance + 120);
        },
        ease: "none",
        duration: 2
    });

    tl.to({}, { duration: 0.5 });

    const endOffset = scrollDistance + 200;

    return ScrollTrigger.create({
        trigger: '.policy-autoscroll',
        start: "top 160px",
        end: `+=${endOffset}`,
        scrub: true,
        pin: true,
        pinSpacing: true,
        animation: tl,
        markers: false
    });
}

function handleResize() {
    if(!autoscroll_item) {
        return;
    }

    if (window.innerWidth >= 840) {
        if (window.innerScrollAnim) {
          window.innerScrollAnim.kill();
          gsap.set(".policy-autoscroll__right .inner", { y: 0 });
        }
        window.innerScrollAnim = createScrollAnimation();
    } else {
        if (window.innerScrollAnim) {
          window.innerScrollAnim.kill();
          window.innerScrollAnim = null;
          gsap.set(".policy-autoscroll__right .inner", { y: 0 });
        }
    }
}

// Wait for page to fully load before initializing
window.addEventListener('load', handleResize);

window.addEventListener('resize', handleResize);